<template>
  <el-container style="height: 600px; border: 1px solid #eee" class="chatContainer">
    <el-aside width="300px">
      <ChatRooms @manageRooms="manageTheRooms" @viewRoom="viewRoom"/>
    </el-aside>
    <el-main>
      <div v-if="!manageRooms" v-loading="gettingChatRoom">
        <div v-if="activeChat.label">
        </div>
        <div :class="messageClass(message.username)" v-for="message in activeChatMessages" :key='message.time' v-show="!manageRooms">
          <img :src="imageSrc(message.username)" alt="Avatar" :class="avatarClass(message.username)">
          <span class="messageText">{{ message.text }}</span>
          <div>
            <span class="time-right">
              {{ message.time }}
            </span>
            <span class="time-left">
              {{$t('application')}}: {{ workingApplication.id }}
              {{$t('user')}}: {{ message.username }}
            </span>
          </div>
        </div>
        <div v-show="activeChat.id" v-loading="sendingMessage">
          <div>
            <el-input
              class="inputMessage"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Please input"
              v-model="message">
            </el-input>
            <el-button type="primary" @click="sendMessage">{{$t('send')}}</el-button>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ChatRooms from './ChatRooms'

export default {
  data () {
    return {
      activeChatMessages: {},
      manageRooms: false,
      id: 3,
      message: '',
      perPage: 10,
      currentPage: 1
    }
  },
  components: {
    ChatRooms,
  },
  methods: {
    getNewerMessages () {
      if (this.currentPage > 1) { this.currentPage = this.pacurrentPagege - 1 }
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    getOlderMessages () {
      this.currentPage = this.currentPage + 1
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    refreshChat () {
      this.currentPage = 1
      this.$store.dispatch('GET_CHATROOM', {id: this.activeChat.id, page: this.currentPage, perPage: this.perPage})
    },
    viewRoom () {
      this.manageRooms = false
    },
    manageTheRooms () {
      this.manageRooms = !this.manageRooms
    },
    sendMessage () {
      if (this.message.length > 1000) {
        this.$notify.warning({
          title: `Προειδοποίηση Ασφάλειας`,
          message: `Δεν μπορείτε να στείλετε μηνύματα μεγαλύτερα από 1000 χαρακτήρες.
            Παρακαλώ σπάστε το σε μικρότερα μηνύματα.`,
          offset: 100,
          duration: 6000
        })
      } else {
        this.$store.dispatch('SEND_MESSAGE', {
          text: this.message,
          app_id: this.applicationId,
          chatId: this.activeChat.id
        }).then(res => {
          if (res.text) {
            this.message = ''
            this.applicationId = ''
          }
        })
      }
    },
    isItMe (name) {
      return this.currentUser ? name === this.currentUser.username : ''
    },
    avatarClass (name) {
      return this.isItMe(name) ? '' : 'right'
    },
    imageSrc (name) {
      return this.isItMe(name)
        ? require('../../../assets/whitePone.jpg')
        : require('../../../assets/whiteKnight.jpg')
    },
    messageClass (name) {
      return this.isItMe(name) ? 'message darker' : 'message'
    }
  },
  computed: {
    applicationId () {
      return this.workingApplication.id
    },
    ...mapState(['workingApplication']),
    ...mapGetters({
      currentUser: 'currentUser',
      activeChat: 'activeChat',
      gettingChatRoom: 'gettingChatRoom',
      sendingMessage: 'sendingMessage',
      myAvatar: 'myAvatar'
    })
  },
  watch: {
    activeChat: function (newData, oldData) {
      this.activeChatMessages = newData.messages
    }
  }
}
</script>

<style lang="scss" scoped>

.newerMessagesButton {
  float: right;
}
.olderMessagesButton {
  float: left;
}

.refreshButton {
  float: right;
}

.messageText {
  word-wrap: break-word;
}

.chatLabel {
  background-color: rgba(64,158,255,.1);
  display: inline-block;
  padding: 0 10px;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid rgba(64,158,255,.2);
  white-space: nowrap;
}

.chatContainer {
  text-align: left;
  height: auto;
  line-height: 20px;
  padding:0 20px;
}

.inputAppId {
  width: 15%;
  // float: right;
  // margin-left: 30px;
  margin-right:5px;
  padding: 2px;
}

.el-textarea {
  &.inputMessage {
    width: 75%;
  }
}
 /* Chat messages */
.message {
  border: 2px solid #dedede;
  background-color: #f1f1f1;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

/* Darker chat message */
.darker {
  border-color: #ccc;
  background-color: #ddd;
}

/* Clear floats */
.message::after {
  content: "";
  clear: both;
  display: table;
}

/* Style images */
.message img {
  float: left;
  max-width: 20px;
  width: 100%;
  margin-right: 20px;
  border-radius: 50%;
}

/* Style the right image */
.message img.right {
  float: right;
  margin-left: 20px;
  margin-right:0;
}

/* Style time text */
.time-right {
  float: right;
  color: #aaa;
}

/* Style time text */
.time-left {
  // float: left;
  color: #999;
}
</style>
